var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2.72344L11.25 3.875V1.5C11.25 0.948438 10.8016 0.5 10.25 0.5H1C0.448438 0.5 0 0.948438 0 1.5V10.5C0 11.0516 0.448438 11.5 1 11.5H10.25C10.8016 11.5 11.25 11.0516 11.25 10.5V8.125L13.25 9.27656C13.5828 9.46875 14 9.22812 14 8.84531V3.15625C14 2.77187 13.5828 2.53125 13.25 2.72344ZM10.125 10.375H1.125V1.625H10.125V10.375ZM12.875 7.76562L11.25 6.83125V5.17031L12.875 4.23438V7.76562ZM2.25 3.625H4C4.06875 3.625 4.125 3.56875 4.125 3.5V2.75C4.125 2.68125 4.06875 2.625 4 2.625H2.25C2.18125 2.625 2.125 2.68125 2.125 2.75V3.5C2.125 3.56875 2.18125 3.625 2.25 3.625Z",
    fill: "#005CE6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpVideo);
export default __webpack_public_path__ + "static/media/help_video.01cff5ef2367f5578d8de506873e7c83.svg";
export { ForwardRef as ReactComponent };